<template>
  <div class="u_page">
    <div class="userWrapper">
      <div class="avaterWrapper">

        <img :src="userInfo.avatarUrl" class="avater" v-if="islogged"/>
        <img :src="userInfo.avatarUrl" class="avater"  v-else>
      </div>
      <div class="nameWrapper">
        <div class="name"  v-if="islogged">{{userInfo.nikeName}}</div>
        <div class="name"  v-else>关注搜券王公众号进入网站自动登录获取积分</div>
        <div class="coins"><img src="../../../images/yuanbao.png" class="coins_icon" />{{scoreUserInfo.totalScore?scoreUserInfo.totalScore-scoreUserInfo.usedScore:0}}券币</div>
      </div>
      <!--每日签到
      <signIn></signIn>-->
      <!--个人中心导航-->
    </div>
    <mune></mune>
  </div>

</template>
<script type = "text/ecamscript-6">
import SignIn from '@/components/userCenter/userCenter/SignIn'
import Mune from '@/components/userCenter/userCenter/mune'
  export default {
    name:'userCenter',
    data(){
      return{
        islogged:sessionStorage.islogged,
        userInfo:JSON.parse(sessionStorage.userInfo)
      }
    },
    created(){
    //console.log(this.userInfo)

    },
    methods:{
      login() {
        let url = "api/getUserScoreInfo.php?openID="+this.userInfo.openId
        this.$ajax.autoService.
        login(url).then((res)=>{
          this.totalScore = res.data[0];
        })
      },


    },

    components:{
      'signIn':SignIn,
      'mune':Mune
    },
    computed:{
      scoreUserInfo: function() {
        return this.$store.state.scoreUserInfo
      },

    }
  }
</script>
<style lang="stylus">
.u_page
  .userWrapper
    padding:60px 40px 70px 40px
    background:linear-gradient(to right,#ff0026,#ff6f25)
    display:flex
    position:relative
    .avaterWrapper
      flex:0 0 130px
      box-sizing:border-box
      .avater
        width:130px
        height:130px
        box-sizing:border-box
        border:4px solid #ffa66c
        border-radius:65px
    .nameWrapper
      flex:1
      box-sizing:border-box
      padding:25px 0 0 30px
      color:#fff
      .name
        font-size:28px
      .coins
        font-size:30px
        margin-top:5px
        .coins_icon
          width:40px
          margin-right:10px


</style>



// WEBPACK FOOTER //
// src/components/userCenter/userCenter/userCenter.vue